export const mainCounter = state => state.counters.main
export const mainStep = state => state.step.step



// WEBPACK FOOTER //
// ./src/vuex/getters.js